const network = require('./net.config');
const setting = require('./setting.config');

module.exports = Object.assign({}, network, setting)